import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=684947a8&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=684947a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684947a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Product: require('/var/www/app/components/Product.vue').default})
